import API from "./api";

const AuthService = {
  // Register new student
  register: async (userData) => {
    try {
      const response = await API.post("/auth/register", userData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Login with identifier (email OR phone) and password
  login: async (credentials) => {
    try {
      const response = await API.post("/auth/login", credentials);

      // DEBUG: Log the full response
      console.log("=== LOGIN RESPONSE DEBUG ===");
      console.log("Full response object:", response);
      console.log("response.status:", response.status);
      console.log("response.data:", response.data);
      console.log("response.data.data:", response.data?.data);
      console.log("response.data.data?.token:", response.data?.data?.token);
      console.log("============================");

      if (response.data?.data?.token) {
        localStorage.setItem("token", response.data.data.token);
        localStorage.setItem("user", JSON.stringify(response.data.data.user));
      } else {
        console.error(
          "Token not found! Response structure unexpected:",
          response.data,
        );
        throw new Error("Invalid response from server: Token missing");
      }

      return response.data;
    } catch (error) {
      console.error("Login API error:", error);
      console.error("Error response:", error.response);
      throw error;
    }
  },

  // Logout user
  logout: () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
  },

  // Get current user
  getCurrentUser: () => {
    const user = localStorage.getItem("user");
    return user ? JSON.parse(user) : null;
  },

  // Get token
  getToken: () => {
    return localStorage.getItem("token");
  },

  // Check if user is authenticated
  isAuthenticated: () => {
    return !!localStorage.getItem("token");
  },

  // Get pending users (admin only)
  getPendingUsers: async () => {
    try {
      const response = await API.get("/auth/pending");
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Verify user (admin only)
  verifyUser: async (userId, status) => {
    try {
      const response = await API.put(`/auth/verify/${userId}`, { status });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // NEW: Get student profile
  getProfile: async (userId) => {
    try {
      const response = await API.get(`/auth/profile/${userId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // NEW: Update student profile (email, phone, password)
  updateProfile: async (userId, profileData) => {
    try {
      const response = await API.put(`/auth/profile/${userId}`, profileData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Add after existing methods
  checkPasswordStatus: async () => {
    // This will be handled by login response, but add this helper
    const user = AuthService.getCurrentUser();
    return {
      isDefaultPassword: localStorage.getItem("is_default_password") === "true",
      lastPasswordChange: localStorage.getItem("last_password_change"),
    };
  },
};

export default AuthService;
